var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SecondaryActionButton',{on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v(" mdi-chevron-left ")]),_vm._v(" Back to search ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }